<template>
<div>
    <PreLoader v-if="isLoading"/>
    <SuperAdminSchoolHead>
        <template v-slot:title>{{$t('classes')}}</template>
    </SuperAdminSchoolHead>
    <div class="scl-ad">
        <SmartTable :schools="classes" :total-elements="totalElements" :page-size="pageSize"
                    :current-page="currentPage" :totalPages="totalPages" @leftClick="onLeftClick"
                    @rightClick="onRightClick">
            <template v-slot:firstItem>
                <v-select outlined dense :items="classInstructors" item-text="personTitle" item-value="personId"
                          :label="$t('teacherFilter')" class="select-teacher" @change="filterByInstructor"/>
            </template>
            <template v-slot:head>
                <th v-html="$t('class')"/>
                <th v-html="$t('letter')"/>
                <th v-html="$t('classTeacher')"/>
                <th v-html="$t('language2')"/>
            </template>
            <template v-slot:body="{item}">
                <td v-html="item['classLevel']"/>
                <td v-html="item['classLabel']"/>
                <td v-html="item['personTitle']"/>
                <td v-html="getLanguageName(item['languageId'])"/>
            </template>
        </SmartTable>
    </div>
</div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { LanguageService } from '@/_services/language.service'
import { InstructorCourseService } from '@/_services/instructor-course.service'
import SchoolClassService from '@/_services/school-class.service'
import { InstructorClassService } from '@/_services/instructor-class.service'
import PreLoader from '@/components/preloader/PreLoader'
import ShiftService from '@/_services/shift.service'
const languageService = new LanguageService()
const instructorCourseService = new InstructorCourseService()
const instructorClassService = new InstructorClassService()

export default {
    components: {SuperAdminSchoolHead, SmartTable, PreLoader},
    data () {
        return {
            classes: [],
            languages: [],
            teachers: [],
            classInstructors: [],
            allClasses: [],
            shifts: [],
            allSchoolClasses: [],
            totalPages: 1,
            totalElements: 0,
            size: 10,
            pageSize: 0,
            currentPage: 1,
            isLoading: false,
            existClassLabel: ''
        }
    },
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        }
    },
    created () {
        this.fetchLanguages()
        this.fetchTeachers()
        this.fetchAllInstrClasses(0)
        this.fetchSchoolShifts()
        this.fetchSchoolClasses()
    },
    methods: {
        onLeftClick () {
            this.currentPage--
            this.fetchAllInstrClasses(this.currentPage - 1)
        },
        onRightClick () {
            this.currentPage++
            this.fetchAllInstrClasses(this.currentPage - 1)
        },
        fetchSchoolClasses () {
            SchoolClassService.getAllBySchool(this.userProfile.schools[0].id).then((res) => {
                this.allSchoolClasses = res.map((klass) => {
                    klass.classTitle = `${klass.classLevel} ${klass.classLabel}`
                    return klass
                })
            }).catch((err) => {
                this.$toast.error(err)
            })
        },
        fetchAllInstrClasses (page) {
            instructorClassService.getAllClasses(this.userProfile.schools[0].id, '', page)
                .then((res) => {
                    this.totalElements = res.totalElements
                    this.pageSize = res.pageSize
                    this.totalPages = res.totalPages
                    this.currentPage = res.number + 1
                    if (res.content) {
                        this.classes = res.content.map((i, index) => {
                            i.index = index
                            return i
                        })
                    } else this.classes = []
                    this.classes = this.classes.sort((a, b) => a.classLevel - b.classLevel)
                    this.allClasses = res.content
                    this.classInstructors = JSON.parse(JSON.stringify(res.content))
                    this.classInstructors.unshift({ personId: 0, personTitle: this.$t('showAll') })
                }).catch((err) => this.$toast.error(err))
        },
        fetchSchoolShifts () {
            ShiftService.getAllBySchool(this.userProfile.schools[0].id)
                .then((res) => this.shifts = res)
                .catch((err) => this.$toast.error(err))
        },
        filterByInstructor (instructorId) {
            if (instructorId) this.classes = this.allClasses.filter((klass) => klass.personId === instructorId)
            else this.classes = this.allClasses
        },

        fetchLanguages () {
            languageService.list().then(res => this.languages = res).catch(err => console.log(err))
        },
        getLanguageName (langId) {
            if (langId && this.languages.length) return this.languages.find(lang => lang.id === langId).name
        },
        fetchTeachers () {
            instructorCourseService.getAllWithoutPagination(this.userProfile.schools[0].id)
                .then((res) => {
                    this.teachers = res.content.sort((a, b) => a['instructorTitle'].localeCompare(b['instructorTitle']))})
                .catch((err) => this.$toast.error(err))
        }
    }
}
</script>
